module.exports = __webpack_public_path__ + "img/go-with-freedom.548abd6d.png";